import { HorizontalBar } from 'vue-chartjs'
import chartMixin from './chartMixin'

export default {
  mixins: [HorizontalBar, chartMixin],
}
